export default __webpack_public_path__ + "static/media/teacher-type.7aafc515.svg";